export default "__VITE_ASSET__Co8HsMD2__"